<template>
	<div class="bg-white px-3 index" >
		<div class="add_tits" ref="title">
			<el-form class="form-inlines" :inline="true">
				<el-form-item label="关键词:">
					<el-input v-model="keyword" size="small" placeholder="请输入内容"></el-input>
				</el-form-item>
				<el-form-item label="会议:">
					<el-select v-model="hy_value" placeholder="请选择" size="small" clearable>
						<el-option v-for="item in hy_options" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="ibox-content" v-loading="dcing">
			<div class="b_top">
				<el-button icon="el-icon-printer" :loading='dcing' size="mini" @click="exportExcel">
					导出Excel</el-button>
			</div>
			<el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
				<el-table-column prop="name" label="时间" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{date('Y-m-d H:i:s',scope.row.time)}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="会议名称" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{({1:'第四届中国男科秦淮论坛',2:'无锡泌外微创技术进展',3:'中国民间中医医药研究开发协会生殖与男科第四届年会'})[scope.row.source]}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="姓名" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="age" label="年龄" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="dw" label="单位" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="zc" label="职称" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="phone" label="手机号" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="ch_time" label="参会时间" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{({1:'7月30日',2:'7月31日',87:'8月7日'})[scope.row.ch_time]}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="iszs" label="是否需要住宿" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{({1:'是',2:'否'})[scope.row.iszs]}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="fjtype" label="住宿房间类型" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{({1:'单人间',2:'标准间'})[scope.row.fjtype]}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="jf_value" label="是否需要积分" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{({1:'是',2:'否'})[scope.row.jf_value]}}</span>
					</template>
				</el-table-column>
			</el-table>
			<div class="u-f u-ac u-jsb ft_mr">
				<div></div>
				<div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper" :total="count">
					</el-pagination>
				</div>
			</div>

		</div>

		<div v-show="false">
			<el-table :data="tableData2" border v-loading="loading" :height="heights" id="out-table">

				<el-table-column prop="name" label="姓名" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="age" label="年龄" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="dw" label="单位" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="zc" label="职称" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="phone" label="手机号" show-overflow-tooltip> </el-table-column>
				<el-table-column prop="ch_time" label="参会时间" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{({1:'7月30日',2:'7月31日',87:'8月7日'})[scope.row.ch_time]}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="iszs" label="是否需要住宿" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{({1:'是',2:'否'})[scope.row.iszs]}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="fjtype" label="住宿房间类型" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{({1:'单人间',2:'标准间'})[scope.row.fjtype]}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="jf_value" label="是否需要积分" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{({1:'是',2:'否'})[scope.row.jf_value]}}</span>
					</template>
				</el-table-column>

			</el-table>
		</div>

	</div>
</template>


<script>
	import {
		mapState
	} from 'vuex'
	export default {
		data() {
			return {
				formData: {
					time: '',
					hosname: '',
					hos_options: [],
					province: '',
					pro_options: [],
					city: '',
					city_options: [],
					jobname: '',
					job_options: [],
					ksname: '',
					ks_options: [],
					qdname: '',
					qd_options: [],
					yqrname: '',
					yq_options: [],
				},
				loading: false,
				dcing: false,
				tableData: [],
				tableData2: [],
				currentPage: 1,
				pagesize: 15,
				count: 0,
				heights: null,

				keyword: '',
				contents: [],
				hy_options: [{
						id: 1,
						name: '第四届中国男科秦淮论坛'
					},
					{
						id: 2,
						name: '无锡泌外微创技术进展'
					},
				],
				hy_value: '',
				date: xaoi.date
			};
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		mounted() {
			let that = this
			that.getall()
			that.getHeight()
			that.begin()
		},
		methods: {
			// 获取高度
			getHeight() {
				let that = this;
				var title = that.$refs.title.offsetHeight
				that.heights = window.innerHeight - title - 250 + 'px'
				window.onresize = () => {
					var title = that.$refs.title.offsetHeight
					that.heights = window.innerHeight - title - 250 + 'px'
				}
			},
			begin() {
				let that = this
				that.currentPage = 1
				that.pagesize = 15
				that.search()
			},
			async search() {
				let that = this
				that.tableData = []
				that.loading = true
				let res = await this.ajax('tools/meeting/get', {
					page: that.currentPage,
					limit: that.pagesize,
					sousuo: this.keyword,
					source: this.hy_value
				})
				if (res.code == 200) {
					res.data.data.forEach(ele => {
						var d = JSON.parse(ele.content);
						d.time = ele.create_time
						d.source = ele.source
						that.tableData.push(d)
					})
					that.count = res.data.count
				}
				this.loading = false
			},
			async exportExcel() {
				// var fix = document.querySelector('.el-table__fixed-right');
				let tabs = []
				let arrs = []
				this.tableData2 = []
				let pages = Math.ceil(this.count / 15)
				this.dcing = true
				this.loading = true
				for (let i = 1; i <= pages; i++) {
					let res = await this.ajax('tools/meeting/get', {
						page: i,
						limit: this.pagesize,
						sousuo: this.keyword,
						source: this.hy_value
					})
					if (res.code == 200) {
						let data = res.data.data
						arrs = arrs.concat(data)
					}
				}
				arrs.forEach(ele => {
					var d = JSON.parse(ele.content);
					d.time = ele.create_time
					tabs.push(d)
				})
				if (tabs && tabs.length > 0) {
					this.dcing = false
					this.tableData2 = tabs
				}
				this.$nextTick(() => {
					var xtable = document.querySelector('#out-table')
					this.$excels.exports(xtable, '会议报名表')
				})
				this.loading = false
			},
			handleSizeChange(val) {
				let that = this
				that.pagesize = val;
				that.search()
			},
			handleCurrentChange(val) {
				let that = this
				that.currentPage = val;
				that.search()
			},
			handleEdit(row, index) {
				this.$prompt('请输入执业证书编码', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /\S/,
					inputErrorMessage: '执业证书编码不能为空'
				}).then(({
					value
				}) => {
					axios
						.post("/admin/pc/doctorAudit/updateCertificateCode", {
							certificate_code: value,
							id: row.id
						}, {
							token: true
						}).then(response => {
							this.search()
							this.$message({
								type: 'success',
								message: '操作成功'
							});
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消输入'
					});
				});
			},
			getall() {
				this.gethos()
				this.getjob()
				this.getks()
				this.getyqxx()
				this.all_sheng()
			},
			gethos() {
				axios
					.post("/admin/HospitalSelect", {}, {
						token: true
					})
					.then(response => {
						this.formData.hos_options = response.data.data
					})
					.catch(error => {})
			},
			getjob() {
				axios
					.post("/admin/showCompetentList", {}, {
						token: true
					})
					.then(response => {
						this.formData.job_options = response.data.data
						this.formData.job_options = this.IterDelateChildren(this.formData.job_options)
					})
					.catch(error => {})
			},
			getks() {
				axios
					.post("/admin/showSectionList", {}, {
						token: true
					})
					.then(response => {
						this.formData.ks_options = response.data.data
						this.formData.ks_options = this.IterDelateChildren(this.formData.ks_options)
					})
					.catch(error => {})
			},
			IterDelateChildren(arr) {
				for (let i = 0; i < arr.length; i++) {
					if (arr[i].children) {
						if (arr[i].children.length) {
							this.IterDelateChildren(arr[i].children)
						} else {
							delete arr[i].children
						}
					}
				}
				return arr
			},
			getyqxx() {
				axios
					.post("/admin/DoctorAudit/inviterSelect", {}, {
						token: true
					})
					.then(response => {
						this.formData.yq_options = response.data.data
					})
					.catch(error => {})
			},
			//省
			all_sheng() {
				let that = this
				axios
					.post("/admin/Area/getProvince_vue", {}, {
						token: true
					})
					.then(response => {
						that.formData.pro_options = response.data.data
					})
					.catch(error => {})
			},
			// 市
			getsq() {
				let that = this
				that.formData.city = ''
				that.formData.city_options = []
				axios
					.post("/admin/Area/getChild_vue", {
						parentcode: that.formData.province,
					}, {
						token: true
					})
					.then(response => {
						that.formData.city_options = response.data.data
					})
					.catch(error => {})
			},




		},

	};
</script>


<style lang="scss" scoped>
	.b_top {
		padding: 5px 0;
	}
</style>